import {DropDownFieldDefinition} from '../../fields-definitions/drop-down-field-definition';
import {ILauncherServiceFactory} from '../../../launcher-service-factory.interface';
import {makeConfigurationArea} from '../make-configuration-area';
import {ROOT_CONFIGURATION_KEYS} from '../../root-configuration-keys';

export function makeOrbitConfigurationArea(services: ILauncherServiceFactory) {
    return makeConfigurationArea(ROOT_CONFIGURATION_KEYS.orbit, services, {
       server: new DropDownFieldDefinition('Orbit client', 'URL from where the Orbit java script will be downloaded', [
           {value: 'http://localhost:7070', text: 'DEV - http://localhost:7070'},
           {value: 'http://mirage-cgp-latest-eu.888casino.com', text: 'MIRAGE - http://mirage-cgp-latest-eu.888casino.com'},
           {value: 'http://mgm-cgp-latest-eu.888casino.com', text: 'MGM - http://mgm-cgp-latest-eu.888casino.com'},
           {value: 'http://usqa-cgp-latest-us.888casino.com', text: 'USQA - http://usqa-cgp-latest-us.888casino.com'},
           {value: 'https://cgp-stage-cdn2.safe-iplay.com', text: 'EU_Stage - https://cgp-stage-cdn2.safe-iplay.com'},
           {value: 'https://cgp-cdn2.safe-iplay.com', text: 'EU_Production - https://cgp-cdn2.safe-iplay.com'},
           {value: 'https://cgp-nj.secured-qa.com', text: 'NJPE_Certification - https://cgp-nj.secured-qa.com'},
           {value: 'https://cgp-stg-nj.secured-qa.com', text: 'NJPE_STAGE - https://cgp-stg-nj.secured-qa.com'},
           {value: 'https://cgp-stg-nj.secured-igaming-services.com', text: 'USA_Stage - https://cgp-stg-nj.secured-igaming-services.com'},
           {value: 'https://cgp-nj.secured-igaming-services.com', text: 'USA_Production - https://cgp-nj.secured-igaming-services.com'}
       ]),
        language: new DropDownFieldDefinition('Language ISO3', '', [
            { text: 'ARA', value: 'ara' },
            { text: 'CHI', value: 'chi' },
            { text: 'ENG', value: 'eng' },
            { text: 'FIN', value: 'fin' },
            { text: 'FRE', value: 'fre' },
            { text: 'GER', value: 'ger' },
            { text: 'GRE', value: 'gre' },
            { text: 'ITA', value: 'ita' },
            { text: 'DAN', value: 'dan' },
            { text: 'JPN', value: 'jpn' },
            { text: 'NOR', value: 'nor' },
            { text: 'POR', value: 'por' },
            { text: 'RUS', value: 'rus' },
            { text: 'SPA', value: 'spa' },
            { text: 'SWE', value: 'swe' },
            { text: 'THA', value: 'tha' },
            { text: 'RUM', value: 'rum' }
        ]),
        iso2: new DropDownFieldDefinition('Language ISO2', '', [
            { text: 'AR', value: 'ar' },
            { text: 'EN', value: 'en' },
            { text: 'DE', value: 'de' },
            { text: 'ES', value: 'es' },
            { text: 'IT', value: 'it' },
            { text: 'RU', value: 'ru' },
            { text: 'DK', value: 'da' },
            { text: 'SV', value: 'sv' },
            { text: 'RO', value: 'ro' }
        ]),
        country: new DropDownFieldDefinition('Country', '', [
            { text: 'gbr', value: 'gbr' },
            { text: 'ita', value: 'ita' },
            { text: 'prt', value: 'prt' },
            { text: 'dnk', value: 'dnk' },
            { text: 'esp', value: 'esp' },
            { text: 'che', value: 'che' },
            { text: 'hun', value: 'hun' },
            { text: 'swe', value: 'swe' },
            { text: 'rou', value: 'rou' },
            { text: 'deu', value: 'deu' },
            { text: 'nld', value: 'nld' },
            { text: 'usa', value: 'usa' }
        ]),
        cmsSource: new DropDownFieldDefinition('CMS Source', '', [
            { value: 'https://www.888casino.com' },
            { value: 'https://www.888casino.es' },
            { value: 'https://www.888casino.it' },
            { value: 'https://www.888casino.dk' },
            { value: 'https://www.888casino.se' },
            { value: 'https://www.888casino.pt' },
            { value: 'https://play-www.777.com' },
            { value: 'https://www-ro.888casino.com' },
            { value: 'https://us.888casino.com' },
            { value: 'https://stage-njpe-us.888casino.com' },
            { value: 'https://casino.harringtongamingonline.com' },
            { value: 'https://casino.delawarepark.com' },
            { value: 'https://onlinecasino.doverdowns.com' }
        ]),
        publicationID: new DropDownFieldDefinition('CMS Publication ID', '', [
            { text: '.COM (1841)', value: '1841' },
            { text: 'IT (1870)', value: '1870' },
            { text: 'DK (1867)', value: '1867' },
            { text: 'ES (1884)', value: '1884' },
            { text: 'SE (1880)', value: '1880' },
            { text: '888 nj (1906)', value: '1906' },
            { text: 'harrahs nj (1924)', value: '1924' },
            { text: 'WSOP Casino nj (1927)', value: '1927' },
            { text: 'delawarepark de (1981)', value: '1981' },
            { text: 'doverdowns de (1978)', value: '1978' },
            { text: 'harrington de (1980)', value: '1980' }
        ])
    });
}